export default __webpack_public_path__ + "images/2e5ebd8666b46d12545e9354e7a8fa96-dj.svg";